import React from "react";
import { LottiePlayer } from "../LottiePlayer";
import { ACTION, REDUCER_DEFAULT, Reducer } from "./Main.Reducer";
import { AbsorbanceTable } from "../AbsorbanceTable";
import { AnimationBlock } from "../AnimationBlock";
import { AnimationSlider } from "../AnimationSlider";
import { AnimationZoom } from "../AnimationZoom";
import { RangeSlider } from "../RangeSlider";
import { SliderLabel } from "../SliderLabel";
import { Slider } from "../Slider";
import { ControlBlock } from "../ControlBlock";
import className from "../../Style/style.module.scss";
import { useTranslation } from "react-i18next";

export function Main(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const defaultData = REDUCER_DEFAULT;
  defaultData.switchButtons[0].label = t(
    `${props.sceneData.togglesLabel.toggle1}.string`
  );
  defaultData.switchButtons[1].label = t(
    `${props.sceneData.togglesLabel.toggle2}.string`
  );

  const [state, dispatch] = React.useReducer(Reducer, defaultData);

  const dispatchAction = (type) => (payload) => dispatch({ type, payload });

  const fetchProjectRecord = React.useCallback(async () => {
    try {
      const response = true;
      dispatchAction(ACTION.FETCH_DATA_SUCCESS)(response);
    } catch (error) {
      dispatchAction(ACTION.FETCH_DATA_ERROR)(error);
    }
  }, []);

  React.useEffect(() => {
    fetchProjectRecord();
  }, [fetchProjectRecord]);

  React.useEffect(() => {
    document.title = `LabXchange | ${t(`${props.sceneData.name}.string`)}`;
  }, []);

  const prevAria = () => {
    if (Object.hasOwn(state.ariaLabels, "sliderLabels")) {
      const index = state.ariaLabels.sliderLabels.findIndex(
        (x) =>
          x.wavelengthAriaLabel === state.ariaLabel.wavelengthAriaLabel &&
          x.phValue === state.ariaLabel.phValue &&
          x.wavelengthFrom === state.ariaLabel.wavelengthFrom &&
          x.wavelengthTo === state.ariaLabel.wavelengthTo
      );

      if (
        index !== -1 &&
        index !== 0 &&
        state.ariaLabels.sliderLabels[index - 1].phValue ===
          state.ariaLabel.phValue
      ) {
        let obj;

        if (state.wavelengthSlider.current === state.wavelengthSlider.max) {
          obj = state.ariaLabels.sliderLabels[index];
        } else {
          obj = state.ariaLabels.sliderLabels[index - 1];
        }

        obj.fromFrame = obj.wavelengthFrom;
        obj.toFrame = obj.wavelengthTo;

        return obj;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const nextAria = () => {
    if (Object.hasOwn(state.ariaLabels, "sliderLabels")) {
      const index = state.ariaLabels.sliderLabels.findIndex(
        (x) =>
          x.wavelengthAriaLabel === state.ariaLabel.wavelengthAriaLabel &&
          x.phValue === state.ariaLabel.phValue &&
          x.wavelengthFrom === state.ariaLabel.wavelengthFrom &&
          x.wavelengthTo === state.ariaLabel.wavelengthTo
      );

      if (
        index !== -1 &&
        index !== state.ariaLabels.sliderLabels.length - 1 &&
        state.ariaLabels.sliderLabels[index + 1].phValue ===
          state.ariaLabel.phValue
      ) {
        const obj = state.ariaLabels.sliderLabels[index + 1];

        obj.fromFrame = obj.wavelengthFrom;
        obj.toFrame = obj.wavelengthTo;

        return obj;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  return (
    <>
      <div className={className.widgetWrapper}>
        <AnimationSlider ariaLabel={t(`${state.ariaLabel.content}.string`)}>
          <h1 className={className.widgetHeading}>
            {t(`${props.sceneData.name}.string`)}
          </h1>
          <div
            style={{
              overflow: "hidden",
            }}
          >
            <div className={className.rightContainer}>
              <div
                className={className.rightContainer__tableBlock}
                style={{
                  display:
                    !state.showTableToggle && !state.rangeTableToggle
                      ? "none"
                      : null,
                }}
              >
                {state.showTableToggle && (
                  <AbsorbanceTable
                    data={state.phAbsorbanceData}
                    toggle={state.showTableToggle}
                    phSliderValue={state.absorbanceSlider.current}
                    whiteBackground={
                      props.whiteBackground === true ? true : false
                    }
                  />
                )}

                {/* {state.rangeTableToggle && (
                  <RangeTable
                    data={state.phAbsorbanceData}
                    toggle={state.rangeTableToggle}
                    whiteBackground={props.whiteBackground === true ? true : false}
                  />
                )} */}
              </div>
              <div className={className.rightContainer__graphBlock}>
                <AnimationBlock
                  src={{
                    wide: props.animationData,
                    square: props.animationData,
                    isPath: false,
                  }}
                  orientation={state.orientation}
                  playerComponent={
                    <LottiePlayer
                      loop={false}
                      autoplay={false}
                      animationControl={{
                        "JoyStkCtrl01,Transform,Position": [
                          state.waveLengthRange,
                          0,
                        ],
                        "JoyStkCtrl02,Transform,Position": [state.absValue, 0],
                      }}
                      animationLoaded={dispatchAction(ACTION.ANIMATION_LOADED)}
                    ></LottiePlayer>
                  }
                  zoomComponent={<AnimationZoom />}
                />
              </div>
            </div>
          </div>
          <ControlBlock>
            <Slider>
              <SliderLabel
                id={"slider1"}
                text={`<tag>${t(`${props.sceneData.textLabel}.string`)}</tag>`}
              />
              <RangeSlider
                autoFocus={false}
                labelledby={"slider1"}
                min={state.wavelengthSlider.min}
                max={state.wavelengthSlider.max}
                step={state.wavelengthSlider.step}
                // keyboardStep={state.wavelengthSlider.keyboardStep}
                // altTextData={props.sceneData.altTextData}
                // ariaInterval={ariaInterval}
                nextAria={nextAria()}
                prevAria={prevAria()}
                value={state.wavelengthSlider.current}
                scaleInterval={state.wavelengthSlider.scaleInterval}
                inputLabel={t(`${state.ariaLabel.wavelengthAriaLabel}.string`)}
                onSliderChange={dispatchAction(
                  ACTION.ON_CHANGE_WAVELENGTH_SLIDER
                )}
              />
            </Slider>
            <Slider>
              <SliderLabel
                id={"slider2"}
                text={`<tag>${t(`${props.sceneData.textLabel2}.string`)}</tag>`}
              />
              <RangeSlider
                autoFocus={false}
                labelledby={"slider2"}
                min={state.absorbanceSlider.min}
                max={state.absorbanceSlider.max}
                step={state.absorbanceSlider.step}
                value={state.absorbanceSlider.current}
                scaleInterval={state.absorbanceSlider.scaleInterval}
                inputLabel={t(`${state.ariaLabel.absorbanceAriaLabel}.string`)}
                onSliderChange={dispatchAction(
                  ACTION.ON_CHANGE_ABSORBANCE_SLIDER
                )}
              />
            </Slider>
            {/*
              <SwitchButtonBlock
                switchButtons={state.switchButtons}
                onToggleSwitch={dispatchAction(ACTION.ON_TOGGE_SWITCH)}
                ariaLabels={{
                  "ph_absorbance": t(`${props.sceneData.togglesAltText.ph_absorbance}.string`),
                  "range": t(`${props.sceneData.togglesAltText.range}.string`),
                }}
              />
            */}
          </ControlBlock>
        </AnimationSlider>
      </div>
      {/* {renderDebugInfo()} */}
    </>
  );
}
